import { ButtonPrimary } from '../../../../../../components';
import { Modal } from 'rsuite';
import { PricingScopeLevel } from '../types';
import styles from '../SetupIpaPricingResponsibilities.module.scss';

type LevelChangeModalProps = {
  level: PricingScopeLevel | null;
  assignmentCount: number;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const LevelChangeModal = ({ level, assignmentCount, loading, onCancel, onConfirm }: LevelChangeModalProps) => (
  <Modal className={styles['confirmation-modal']} show={level != null} onHide={onCancel} size="xs">
    <Modal.Header>
      <Modal.Title>Trocar nível de categoria</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        Ao trocar para <strong>{level ? `${level.level} - ${level.name}` : ''}</strong>, removemos as{' '}
        <strong>
          {assignmentCount} {assignmentCount === 1 ? 'atribuição' : 'atribuições'}
        </strong>{' '}
        já configuradas. Os usuários seguem cadastrados no IPA, apenas o vínculo com as categorias é perdido.
      </p>
      <small>Você vai precisar refazer as atribuições no novo nível.</small>
    </Modal.Body>
    <Modal.Footer>
      <ButtonPrimary size="medium" theme="ghost" type="button" onClick={onCancel}>
        cancelar
      </ButtonPrimary>
      <ButtonPrimary size="medium" isLoading={loading} type="button" onClick={onConfirm}>
        trocar nível
      </ButtonPrimary>
    </Modal.Footer>
  </Modal>
);
